import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useLayoutEffect, useRef, useState } from 'react';
import { FormGroup, FormControl, Button, Row, Col } from '@cancercentrum/rcc-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo, faSearch } from '@fortawesome/free-solid-svg-icons';
import { useMemo } from 'react';
import debounce from 'lodash/debounce';
import { useI18n } from '../../i18n';
const FilterInput = (props)=>{
    const { initialValue, isActive, focus, onChange, clearSort, debounce: debounceInterval = 500, hideResetFilterButton } = props;
    const inputRef = useRef(null);
    const [value, setValue] = useState(initialValue || '');
    const focusFn = useCallback(()=>{
        if (inputRef.current) {
            inputRef.current.focus?.();
            inputRef.current.select?.();
        }
    }, [
        inputRef
    ]);
    const initialValueRef = useRef(value);
    if (initialValue !== initialValueRef.current) {
        setValue(initialValue);
    }
    initialValueRef.current = initialValue;
    useLayoutEffect(()=>{
        if (focus) {
            focusFn();
        }
    }, [
        focus,
        focusFn
    ]);
    const triggerChange = useMemo(()=>debounce(onChange, debounceInterval), [
        onChange,
        debounceInterval
    ]);
    const { t } = useI18n();
    const onChangeCb = useCallback((e)=>{
        setValue(e.target.value);
        triggerChange(e.target.value);
    }, [
        setValue,
        triggerChange
    ]);
    const clearFilter = ()=>{
        setValue('');
        onChange('');
        clearSort();
    };
    const resetFilterText = t('component.grid.resetFilter');
    const filterPlaceholder = t('component.grid.filterPlaceholder');
    return /*#__PURE__*/ _jsxs(Row, {
        children: [
            /*#__PURE__*/ _jsx(Col, {
                children: /*#__PURE__*/ _jsx(FormGroup, {
                    validationState: isActive ? 'success' : undefined,
                    children: /*#__PURE__*/ _jsx(FormControl, {
                        ref: inputRef,
                        placeholder: filterPlaceholder,
                        type: "search",
                        icon: faSearch,
                        value: value,
                        onChange: onChangeCb,
                        "data-testid": "GridFilter"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Col, {
                md: 4,
                children: !hideResetFilterButton && /*#__PURE__*/ _jsxs(Button, {
                    bsStyle: "default-2",
                    className: "text-nowrap",
                    onClick: clearFilter,
                    children: [
                        /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                            icon: faUndo,
                            className: "me-1"
                        }),
                        resetFilterText
                    ]
                })
            })
        ]
    });
};
export default /*#__PURE__*/ memo(FilterInput);
